export default __webpack_public_path__ + "static/media/SENAIT_FR_SEQ14.e0d53b97.mp3";